import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import {
  AccordionIcon as ChakraAccordionIcon,
  AccordionIconProps as ChakraAccordionIconProps,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type AccordionIconProps = OmitChakraProps<
  ChakraAccordionIconProps,
  'as'
>;

export const AccordionIcon = (props: AccordionIconProps) => {
  return <ChakraAccordionIcon {...props} as={IconChevronDown} />;
};
